import { PropertyTypeUseCase } from "./PropertyTypeUseCase";

export default class SmartmlsPropertyTypeUseCase implements PropertyTypeUseCase {
    propertyTypeRules: object;
    propertySubTypeRules: object;
    constructor() {
        this.propertyTypeRules = {
            'Commercial For Sale': 'Commercial',
            'Lots and Land For Sale': 'Lots and Land',
            'Single Family For Sale': 'Single Family',
            'Condo/Co-Op For Sale': 'Condo/Co-Op',
            'Multi-Family For Sale': 'Multi-Family'
        }
    }
    getPropertyType = (propertyTypeDescription: string | undefined, propertySubTypeDescription: string | undefined): string | undefined => {
        let newPropertyTypeValue = propertyTypeDescription;
        if (this.propertyTypeRules[propertyTypeDescription!]) {
            newPropertyTypeValue = this.propertyTypeRules[propertyTypeDescription!];
        }
        const clearPropertyType = (propertyTypeDescription === 'Single Family For Sale' 
                                    || propertyTypeDescription === 'Condo/Co-Op For Sale'
                                    || (propertyTypeDescription === 'Residential Rental'
                                    && propertySubTypeDescription !== 'Other'))
                                    && !!propertySubTypeDescription;
    
        if ( clearPropertyType ) {
            newPropertyTypeValue = undefined
        }
    
        return newPropertyTypeValue
    }

    getPropertySubType = (propertyTypeDescription: string | undefined, propertySubTypeDescription: string | undefined): string | undefined => {
        return propertySubTypeDescription
    }
}